import {AfterViewInit,Component,OnInit,ViewChild,NgZone,ElementRef,VERSION,Inject,Input,ChangeDetectorRef} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpClientModule } from "@angular/common/http";
import { DataTableDirective } from "angular-datatables";
import { DOCUMENT } from '@angular/common';
import { logbaseService } from "../../services/logbase.service";
import { dataService } from "../../services/data.service";
import { DatePipe } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { dateFormatPipe } from "../../pipes/dateFormatPipe";
import { MatTableDataSource } from "@angular/material/table";

import {map} from "rxjs/operators"

export interface JunData{
  supplierCode:any;
  supplierName:any;
  specification:any;
  location:any;
  fc1:any;fc2:any;fc3:any;fc4:any;fc5:any;fc6:any;

}

@Component({
  selector: "app-po-fcjun",
  templateUrl: "./po-fcjun.component.html",
  styleUrls: ["./po-fcjun.component.scss"]
})


export class PoFcjunComponent implements OnInit {
  dataSource: MatTableDataSource<JunData[]>;
  cycleLength:any;
  resultData: any;
  junData: any;
  locDD = [];
  suppDD: any[];
  monthLabels: any[];
  QuantityChartData: any[];
  WeightChartData: any[];
  VolumeChartData: any[];
  junView: any;
  suppCodeTbl: any;
  locCodeTbl: any;
  filterJunData: any;
  fcJunData: any;
  suppCodeList: any[];
  dropdownSettings: any;
  locCodeList: any;
  supPoint: any;
  locCode: any;
  cycleDetails: any;
  chartOpt = {
    scaleShowVerticalLines: false,
    responsive: true,
    legend: { position: 'top' },
    scales: {
      xAxes: [
        {
          stacked: true,
          gridLines: {
            drawOnChartArea: false
          }
        }
      ],
      yAxes: [
        {
          stacked: true,
          gridLines: {
            drawOnChartArea: false
          }
        }
      ]
    }
  };


  displayedColumns:any[]=['supplierCode','supplierName','specification','location','Jun1','Jun2','Jun3','Jun4','Jun5','Jun6']

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public thirdLabels: string[] = [
    // "Avg 3 Jun",
    "Jun 1",
    "Jun 2",
    "Jun 3",
    "Jun 4",
    "Jun 5"
  ];
  public barChartType: string = "bar";
  public barChartLegend: boolean = true;
  public lineChartColors: Array<any> = [
    {
      // First
      backgroundColor: "#004355",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    },
    {
      // Second
      backgroundColor: "#00677E",
      borderColor: "rgba(77,83,96,1)",
      pointBackgroundColor: "rgba(77,83,96,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(77,83,96,1)"
    },
    {
      // Third
      backgroundColor: "#007892",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    },
    {
      // Fourth
      backgroundColor: "#0787A5",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    },
    {
      // Fifth Top
      backgroundColor: "#A7C9D8",
      borderColor: "rgba(148,159,177,1)",
      pointBackgroundColor: "rgba(148,159,177,1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(148,159,177,0.8)"
    }
  ];

  // ng2-table code

  public rows: Array<any> = [];
  public columns: Array<any> = [
    { title: "Supplier Code", name: "supplierCode", sort: false },
    { title: "Supplier Name", name: "supplierName", sort: false },
    { title: "Location", name: "location", sort: false },
    { title: "Spec", name: "specification", sort: false },
    // { title: "Avg for last 3 months", name: "avg", sort: false },
    {
      title: "",
      name: "fc1", sort: false
    },
    {
      title: "",
      name: "fc2", sort: false
    },
    {
      title: "",
      name: "fc3", sort: false
    }
  ];
  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;

  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: "" },
    className: ["table-striped", "table-bordered", "poTable"]
  };

  public data: Array<any> = [];
  public graphLocStg: any;
  public dropdownSingle: any;
  public graphDispBtn: any = true;
  graphSuppDD: any[];

  constructor(
    private logbaseService: logbaseService,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    private ref: ChangeDetectorRef,
    private translate: TranslateService

  ) { }

  ngOnInit() {
    // Angular2 multi select settings and config
    this.dropdownSettings = {
      idField:'id',
      textField:'itemName',
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      itemsShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true
    };

    this.dropdownSingle = {
      singleSelection: true,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: false,
      enableSearchFilter: true
    };

    this.graphLocStg = {
      idField:'id',
      textField:'itemName',
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      disabled: true

    };

    // this.getPOSupplierCode();
    // this.getPlantNames();

    this.setFilterData();

    this.onChangeTable(this.config, true);
    this.toGetSupplierCode();

    this.VolumeChartData = [];
    this.WeightChartData = [];
    this.QuantityChartData = [];
  }

  // events
  public chartClicked(e: any): void { }

  public chartHovered(e: any): void { }

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? start + page.itemsPerPage : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== "" && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === "desc" ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === "asc" ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(
          this.config.filtering.filterString
        )
      );
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name]) {
          if (
            item[column.name].toString().match(config.filtering.filterString)
          ) {
            flag = true;
          }
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    this.spinner.show();
    var pageNo;
    var sortData;

    var locSelected = [];
    var suppSelected = [];

    var dateFormatPipeFilter = new dateFormatPipe();

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
      } else {
        sortData = {
          name: "",
          sort: ""
        };
      }
    });

    if (this.locCodeTbl) {
      this.locCodeTbl.forEach(function (value, key) {
        locSelected.push(value.itemName);
      });
    }

    if (this.suppCodeTbl) {
      this.suppCodeTbl.forEach(function (value, key) {
        suppSelected.push(value.itemName);
      });
    }

    if (locSelected.length <= 0) {
      locSelected = [];
    }

    if (suppSelected.length <= 0) {
      suppSelected = [];
    }

    if (this.locCode) {
      this.locCode.forEach(function (value, key) {
        locSelected.push(value.itemName);
      });
    }

    if (this.supPoint) {
      this.supPoint.forEach(function (value, key) {
        suppSelected.push(value.itemName);
      });
    }

    if (locSelected.length <= 0) {
      locSelected = [];
    }

    if (suppSelected.length <= 0) {
      suppSelected = [];
    }

    var dataToSend = {
      pageNum: pageNo,
      searchValue: this.config.filtering.filterString,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      location: locSelected,
      suplierCode: suppSelected
    };

    this.logbaseService.getFcDailyData(dataToSend).subscribe(result1 => {
      this.cycleDetails = result1;
      this.cycleLength=this.cycleDetails.response.content.length
    })
    this.logbaseService.getFcJunData(dataToSend).subscribe(result => {
      this.junView = result;
      var viewArr;
      var viewData = [];
      var graphVolData = [];
      var graphWgtData = [];
      var graphQtyData = [];
      var setVolData: any;
      var setQtyData: any;
      var setWgtData: any;
      var graphLoc = [];
      var actualAvgLast3CycleQty;
      var actualAvgLast3CycleWeight;
      var actualAvgLast3CycleVolume;

      this.junView.response.content.forEach(function (value, key) {
        value.locDetails.forEach(function (val, key) {
          setVolData = [
            // eval(val.actualAvgLast3CycleVolume),
            val.jun1Volume,
            val.jun2Volume,
            val.jun3Volume,
            val.jun4Volume,
            val.jun5Volume
          ];

          setWgtData = [
            // eval(val.actualAvgLast3CycleWeight),
            val.jun1Weight,
            val.jun2Weight,
            val.jun3Weight,
            val.jun4Weight,
            val.jun5Weight
          ];

          setQtyData = [
            // eval(val.actualAvgLast3CycleQty),
            val.jun1Quantity,
            val.jun2Quantity,
            val.jun3Quantity,
            val.jun4Quantity,
            val.jun5Quantity
          ];

          graphLoc.push(val.locationName);

          graphVolData.push(setVolData);
          graphWgtData.push(setWgtData);
          graphQtyData.push(setQtyData);

          if (val.actualAvgLast3CycleQty == null) {
            actualAvgLast3CycleQty = 0;
          } else {
            actualAvgLast3CycleQty = val.actualAvgLast3CycleQty;
          }
          if (val.actualAvgLast3CycleWeight == null) {
            actualAvgLast3CycleWeight = 0;
          } else {
            actualAvgLast3CycleWeight = val.actualAvgLast3CycleWeight;
          }
          if (val.actualAvgLast3CycleVolume == null) {
            actualAvgLast3CycleVolume = 0;
          } else {
            actualAvgLast3CycleVolume = val.actualAvgLast3CycleVolume;
          }
          if (value.supplierNameEN === undefined || value.supplierNameEN === 'null') {
            value.supplierNameEN = '-';
          }
          viewArr = {
            supplierCode: value.supplierCode,
            supplierName: value.supplierNameEN,
            specification:
              '<td class="no-pad rmPad"><div class="fullRow">Quantity</div><div class="fullRow">Weight</div><div class="fullRow">Volume</div></td>',
            location: val.locationName,
            // avg:
            //   '<td class="no-pad"><div class="fullRow">' +
            //   parseFloat(actualAvgLast3CycleQty.toFixed(2)) +
            //   '</div><div class="fullRow">' +
            //   parseFloat(actualAvgLast3CycleWeight.toFixed(2)) +
            //   '</div><div class="fullRow">' +
            //   parseFloat(actualAvgLast3CycleVolume.toFixed(2)) +
            //   "</div></td>",
            fc1:
              '<td class="no-pad"><div class="fullRow">' +
              parseFloat(val.jun1Quantity.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.jun1Weight.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.jun1Volume.toFixed(2)) +
              "</div></td>",
            fc2:
              '<td class="no-pad"><div class="fullRow">' +
              parseFloat(val.jun2Quantity.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.jun2Weight.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.jun2Volume.toFixed(2)) +
              "</div></td>",
            fc3:
              '<td class="no-pad"><div class="fullRow">' +
              parseFloat(val.jun3Quantity.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.jun3Weight.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.jun3Volume.toFixed(2)) +
              "</div></td>",
            fc4:
              '<td class="no-pad"><div class="fullRow">' +
              parseFloat(val.jun4Quantity.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.jun4Weight.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.jun4Volume.toFixed(2)) +
              "</div></td>",
            fc5:
              '<td class="no-pad"><div class="fullRow">' +
              parseFloat(val.jun5Quantity.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.jun5Weight.toFixed(2)) +
              '</div><div class="fullRow">' +
              parseFloat(val.jun5Volume.toFixed(2)) +
              "</div></td>",
            fc6:
              '<td class="no-pad"><div class="fullRow">' +
              val.jun6Quantity +
              '</div><div class="fullRow">' +
              val.jun6Weight +
              '</div><div class="fullRow">' +
              val.jun6Volume +
              "</div></td>"
          };
          viewData.push(viewArr);
        });

      });

      this.data = viewData;
      this.dataSource=new MatTableDataSource<JunData[]>(this.data)


      this.columns = [
        { title: this.translate.instant("Supplier Code"), name: "supplierCode", sort: false },
        { title: this.translate.instant('Supplier Name'), name: "supplierName", sort: false },
        { title: this.translate.instant("Location"), name: "location", sort: false },
        { title: this.translate.instant("Spec"), name: "specification", sort: false },
        // { title: "Avg for last 3 Jun", name: "avg", sort: false },
        {
          title: " Jun 1",
          name: "fc1", sort: false
        },
        {
          title: "Jun 2",
          name: "fc2", sort: false
        },
        {
          title: "Jun 3",
          name: "fc3", sort: false
        },
        {
          title: "Jun 4",
          name: "fc4", sort: false
        },
        {
          title: "Jun 5",
          name: "fc5", sort: false
        }
      ];

      this.length = this.junView.response.totalElements;

      let filteredData = this.changeFilter(this.data, this.config);
      let sortedData = this.changeSort(filteredData, this.config);
      this.rows =
        page && config.paging ? this.changePage(page, sortedData) : sortedData;
      //this.length = sortedData.length;

      this.rerenderTable(this.config, true);
      this.ref.detectChanges();
      this.spinner.hide();
    });
  }

  public rerenderTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows =
      page && config.paging ? this.changePage(page, sortedData) : sortedData;
    //this.length = sortedData.length;
  }

  setFilterData() {
    // Set filter data
    this.spinner.show();

    var locCode = [];
    var suppCode = [];
    var dataResult: any;
    var suppCodeDD = [];
    var locCodeDD = [];

    var dataToSend = {
      pageNum: 0,
      searchValue: this.config.filtering.filterString,
      size: this.itemsPerPage,
      sortColumn: "",
      sortType: "",
      location: [],
      suplierCode: []
    };

    let userDetJson = JSON.parse(localStorage.getItem('userDetails'));
    this.logbaseService.getFcJunData(dataToSend).subscribe(result => {
      dataResult = result;

      dataResult.response.content.forEach(function (value, key) {
        suppCode.push(value.supplierCode);

        value.locDetails.forEach(function (val, key) {
          locCode.push(val.locationName);
        });
      });

      suppCode.filter((x, i, a) => a.indexOf(x) == i);

      suppCode.forEach(function (value, key) {
        suppCodeDD.push({ id: key, itemName: value });
      });

      // if (userDetJson.supplierCode.length > 0) {
      //   userDetJson.supplierCode.forEach(function(value, key) {
      //     suppCodeDD.push({ id: suppCodeDD.length + 1, itemName: value });
      //   });
      // }
      // this.suppDD = suppCodeDD;
      // locCode.filter((x, i, a) => a.indexOf(x) == i);

      // locCode.forEach(function(value, key) {
      //   locCodeDD.push({ id: key, itemName: value });
      // });
      // this.locDD = locCodeDD;
      this.spinner.hide();
    });
  }

  resetDD() {
    this.locCodeTbl = [];
    this.suppCodeTbl = [];
    this.locCode = [];
    this.supPoint = [];

    this.graphDispBtn = true;

    // Enable the location dropdown
    this.graphLocStg = {
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      disabled: true
    };

    this.VolumeChartData = [];
    this.WeightChartData = [];
    this.QuantityChartData = [];

    this.onChangeTable(this.config, true);
  }

  toGetSupplierCode() {
    this.spinner.show();
    this.logbaseService.getAllSupplierCode({ "supplierCodes": [] }).subscribe(result => {
      let supplierCode;
      supplierCode = result;
      let suppCodeDD = [];
      let graphSuppDD = [];
      if (supplierCode.response.length > 0) {
        supplierCode.response.forEach(function (value, key) {
          suppCodeDD.push({ id: suppCodeDD.length + 1, itemName: value.supplierCode });
          graphSuppDD.push({ label: value.supplierCode, value: value.supplierCode });

        });
      }
      this.suppDD = suppCodeDD;
      this.graphSuppDD = graphSuppDD;
      this.spinner.hide();
    });
  }

  onSupplierCodeSelect(item: any) {
    this.locCodeTbl = []
    this.toGetLocationCode(this.toGetFormatedsendBody(this.suppCodeTbl));
  }
  OnSupplierCodeDeSelect(item: any) {
    this.locCodeTbl = []
    if (this.suppCodeTbl.length > 0) {
      this.toGetLocationCode(this.toGetFormatedsendBody(this.suppCodeTbl));
    } else {
      this.locDD = [];
      this.onChangeTable(this.config, true);
    }
  }

  onSupplierCodeSelectAll(items: any) {
    this.locCodeTbl = []
    this.toGetLocationCode(this.toGetFormatedsendBody(items));
  }

  onSupplierCodeDeSelectAll(items: any) {
    this.locCodeTbl = []
    this.locDD = [];
    this.onChangeTable(this.config, true);
  }

  toGetLocationCode(locationCode) {
    this.spinner.show();
    this.logbaseService.getAllSupplierJuneCode(locationCode).subscribe(result => {
      let LocationCode;
      LocationCode = result;
      let temp = []
      if (LocationCode.response.length > 0) {
        for (let index = 0; index < LocationCode.response.length; index++) {
          if (LocationCode.response.length > 0) {
            if (LocationCode.response[index].locationDetails !== undefined &&
              LocationCode.response[index].locationDetails.length > 0) {
              for (let j = 0; j < LocationCode.response[index].locationDetails.length; j++) {
                temp.push(LocationCode.response[index].locationDetails[j]);
              }
            }
          }
        }
      }
      let locCodeDD = [];
      if (temp.length > 0) {
        temp.forEach(function (value, key) {
          locCodeDD.push({ id: locCodeDD.length + 1, itemName: value });
        });
      } else {
        locCodeDD = [];
      }
      const resultArray = [];
      const map = new Map();
      for (const item of locCodeDD) {
        if (!map.has(item.itemName)) {
          map.set(item.itemName, true);    // set any value to Map
          resultArray.push({
            id: item.id,
            itemName: item.itemName
          });
        }
      }
      let uniqueArray = []
      if (resultArray.length > 0) {
        resultArray.forEach(function (value, key) {
          uniqueArray.push({ id: uniqueArray.length + 1, itemName: value.itemName.location });
        });

      }

      this.locDD = uniqueArray;
      this.spinner.hide();
    });
  }

  toGetFormatedsendBody(data) {
    let returnBody = { "supplierCodes": [] }
    if (data.length > 0) {
      for (let index = 0; index < data.length; index++) {
        returnBody.supplierCodes.push(data[index].itemName);
      }
    }
    return returnBody
  }

  onGraphSuppSel(item: any) {

    var responseData;

    // Disable the location dropdown
    this.graphLocStg = {
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      disabled: false
    };

    this.graphDispBtn = false;

    this.locCode = [];

    this.logbaseService.junGraphView(item.value).subscribe(result => {

      responseData = result;
      var locCodeList: any = [];

      if (responseData.response.locDetails) {

        responseData.response.locDetails.forEach(function (value, key) {
          locCodeList.push({ id: key, itemName: value.locationName });
        });

        this.locDD = locCodeList;
      }
    });
  };

  onGraphSuppDeSel(item: any) {
    this.locCode = [];

    this.graphDispBtn = true;

    // Enable the location dropdown
    this.graphLocStg = {
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      disabled: true
    };
  };

  showGraphData() {
    this.spinner.show();

    this.VolumeChartData = [];
    this.WeightChartData = [];
    this.QuantityChartData = [];

    var suppID = this.supPoint;
    var responseData: any;
    var graphLoopData;
    var locName = [];

    this.logbaseService.junGraphView(suppID).subscribe(result => {

      responseData = result;
      this.resultData = responseData.response;
      this.junData = responseData.response.locDetails
      var volDataArr: any = [];
      var wgtDataArr: any = [];
      var qtyDataArr: any = [];
      var volChartData: any = [];
      var filterLoc;
      var filterLocData: any = [];
      var fullVolData: any = [];
      var fullWgtData: any = [];
      var fullQtyData: any = [];

      var wgtChartData: any = [];
      var qtyChartData: any = [];

      if (this.locCode != null) {
        this.locCode.forEach(function (value, key) {
          filterLoc = responseData.response.locDetails.filter(item => item.locationName == value.itemName);
          filterLocData.push(filterLoc[0]);
        });

        if (filterLocData.length > 0) {
          graphLoopData = filterLocData;
        } else {
          graphLoopData = responseData.response.locDetails;
        }
      }

      if (graphLoopData) {
        graphLoopData.forEach(function (value, key) {

          let gvoldata = [];
          let gwgtdata = [];
          let gqtydata = [];

          // gvoldata.push(value.actualAvgLast3CycleVolume);
          gvoldata.push(value.jun1Volume);
          gvoldata.push(value.jun2Volume);
          gvoldata.push(value.jun3Volume);
          gvoldata.push(value.jun4Volume);
          gvoldata.push(value.jun5Volume);
          fullVolData.push(gvoldata);

          // gwgtdata.push(value.actualAvgLast3CycleWeight);
          gwgtdata.push(value.jun1Weight);
          gwgtdata.push(value.jun2Weight);
          gwgtdata.push(value.jun3Weight);
          gwgtdata.push(value.jun4Weight);
          gwgtdata.push(value.jun5Weight);
          fullWgtData.push(gwgtdata);

          // gqtydata.push(value.actualAvgLast3CycleQty);
          gqtydata.push(value.jun1Quantity);
          gqtydata.push(value.jun2Quantity);
          gqtydata.push(value.jun3Quantity);
          gqtydata.push(value.jun4Quantity);
          gqtydata.push(value.jun5Quantity);
          fullQtyData.push(gqtydata);

          locName.push(value.locationName);

          volChartData.push(fullVolData);
          wgtChartData.push(fullWgtData);
          qtyChartData.push(fullQtyData);
        });
      }

      volChartData.forEach(function (value, key) {
        volDataArr.push({ data: value[key], label: locName[key] })
      });

      wgtChartData.forEach(function (value, key) {
        wgtDataArr.push({ data: value[key], label: locName[key] })
      });

      qtyChartData.forEach(function (value, key) {
        qtyDataArr.push({ data: value[key], label: locName[key] })
      });


      this.VolumeChartData = volDataArr;
      this.WeightChartData = wgtDataArr;
      this.QuantityChartData = qtyDataArr;

      this.spinner.hide();
    });
  }

}
